/**
 * @deprecated use migrated version `src/app/shared/components/select-single/select-single.component.ts`.
 */
export function selectSingle() {
  return {
    restrict: 'E',
    template: require('./select-single.directive.html'),
    scope: {
      model: '=',
      placeholder: '@',
      items: '=', // [{id: 123, label: 'Text for 123', iconClass?: 'task-icon facebook', sortKey?: 'text for123-1}]
      readonly: '<',
      optional: '<?',
      reverseSort: '<?',
      localStorageKey: '<?',
      label: '<?',
      onChangeFn: '&?onChange',
      onCloseFn: '&?onClose',
      enableTypeahead: '<?',
    },
    controller: controller
  };
}


controller.$inject = ['$scope', 'LocalStorageFactory'];
function controller($scope, LocalStorageFactory) {

  $scope.callOnClose = callOnClose;
  $scope.callOnChange = callOnChange;

  // Used with enableTypeahead flag at true.
  $scope.updateGlobalSearch = _updateGlobalSearch;
  $scope.clearGlobalSearch = _clearGlobalSearch;

  init();

  function _updateGlobalSearch() {
    $scope.globalSearch = this.globalSearch;
  }

  function _clearGlobalSearch() {
    this.globalSearch = '';
    $scope.globalSearch = this.globalSearch;
  }

  function loadFromLocalStorage() {
    if ($scope.localStorageKey) {
      let value = LocalStorageFactory.getItem($scope.localStorageKey);
      if (value !== null) {
        $scope.model = value;
      }
    }
  }

  function saveToLocalStorage() {
    if ($scope.localStorageKey) {
      LocalStorageFactory.setItem($scope.localStorageKey, $scope.model);
    }
  }

  function callOnChange() {
    if ($scope.onChangeFn) {
      $scope.onChangeFn();
    }
  }

  function callOnClose() {
    if ($scope.onCloseFn) {
      $scope.onCloseFn();
    }
  }

  function init() {
    if (!$scope.model) {
      loadFromLocalStorage();
    }

    // Work around ng-ifs and ng-repeats creating child scopes 
    // (see e.g. https://stackoverflow.com/questions/18342917/angularjs-ng-model-doesnt-work-inside-ng-if )
    $scope.directiveModel = {
      'value': $scope.model
    }
    // But in addition we need to forward any new value up to our parent scope 
    // (angular watches $scope.model because we declared it with '=' in the directive definition)
    $scope.$watch("directiveModel.value", newValue => {
      $scope.model = newValue;
      saveToLocalStorage();
    });
  }
} 